'use client';

import { Accordion, AccordionItem, AccordionPanel } from '@chakra-ui/react';
import { FC } from 'react';
import FilterItemsGroupName from '@/components/UI/Filter/FilterItemsGroupName';
import ValueRangeSlider from '@/components/Product/Filters/ValueRangeSlider';
import { IProductCurrency } from '@/types/product';
import { VALUE_RANGE_MAX, VALUE_RANGE_MIN } from '@/constants/product';

interface ValueFilterProps {
  range?: number[];
  onRangeChange?: (range: number[]) => void;
}
const ValueFilter: FC<ValueFilterProps> = ({
  range = [0, 10_000],
  onRangeChange,
}) => {
  return (
    <Accordion
      defaultIndex={[0]}
      allowMultiple
      onClick={(e) => e.stopPropagation()}
    >
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <FilterItemsGroupName isExpanded={isExpanded}>
              Value
            </FilterItemsGroupName>
            <AccordionPanel mt="1rem" px="0" py="0">
              <ValueRangeSlider
                range={range}
                onRangeChange={(range) => onRangeChange?.(range)}
                rangeMin={VALUE_RANGE_MIN}
                rangeMax={VALUE_RANGE_MAX}
                currency={IProductCurrency.usd}
              />
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default ValueFilter;
